'use client';

import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const APPLICATION_FILES_QUERY_KEY = 'application-files';

const API_DOCUMENTATION_FILE_TYPE = 'SWAGGER';

export function useHasApiDocumentation({
  applicationId,
  enabled = true,
}: {
  applicationId: string | undefined;
  enabled?: boolean;
}) {
  const { data } = useQuery({
    queryKey: [APPLICATION_FILES_QUERY_KEY, applicationId],
    queryFn: () => {
      if (!applicationId) {
        throw new Error('Application ID is required');
      }

      return terraProxyApiClient.getApplicationFiles(applicationId);
    },
    enabled: enabled && Boolean(applicationId),
    refetchOnWindowFocus: false,
  });

  return (data?.files ?? []).some(
    (file) => file.type === API_DOCUMENTATION_FILE_TYPE,
  );
}
